/*
 * Copyright (c) 2024 Ask Sage, Inc. All rights reserved.
 * This software is the confidential and proprietary information of Ask Sage, Inc.
 * You shall not disclose such confidential information and shall use it only in
 * accordance with the terms of the license agreement you entered into with Ask Sage, Inc.
 * THIS SOFTWARE IS PROVIDED "AS IS" AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 * INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL ASK SAGE, INC.
 * OR ITS CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT
 * OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
 * STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 * You may not use this software except in compliance with the License.
 * You may not modify, reverse engineer, or redistribute this software.
 */
import React, { useState, useEffect } from 'react';
import SideMenu from './SideMenu.js'
import MemoMenu from './MemoMenu.js'
import { ChatBox } from './ChatBox.js'
import FilePopup from './Popups/FilePopup.js'
import { getWithExpiry, getBotSettingItem, isBotLoggedIn, getName, logout, getToken, isAdminLoggedIn, getUser } from '../AuthService.js'
import { proposeModelCount, getTokenizerR, getTokenWindowR, isCUICapableR, getModelInfoR, parseMessage } from '../Utils/GenAI_helper.js'
import * as default_data from '../config.js'
import { v4 as uuidv4 } from "uuid";
import Modal from 'react-modal';
import { urlify, strip, unEscapeHTML, escapeHTML } from '../Utils/text_functions.js'
import { addSource, deleteSource, getFilteredSourceContent } from './Source/SourceManagement.js'
import { addMemo, deleteMemo, getFilteredMemoContent } from './Memo/MemoManagement.js'
import { Chip, Box, Dialog, DialogTitle, Button, Card, CardContent, IconButton, Stack, useMediaQuery } from '@mui/material';
import { FiShare2, FiArrowLeft, FiMenu } from 'react-icons/fi';
import { IoClose } from 'react-icons/io5';
import { ScrollableDialogContent } from '../Components/ScrollableDialogContent.js';
import { MarkdownRenderer } from '../Chat/MarkdownRenderer';
import { ShareWorkbookDialog } from './Workbook/AssignWorkbook.js'
import AddURL from './Source/AddURL.js' 
import { validateFile, removeMetadata } from '../Utils/file_functions.js'
import * as log from 'loglevel'
import { useTheme } from '@emotion/react';
import { Navbar } from '../Chat/Navbar.js';
import { getBannerColor } from '../Utils/classification_helper.js';
import { scrollToBottom, trimChatHistoryByCount } from '../Utils/chatHelpers.js';

const Workbook = ({workbook}) => {
    const [sources, setSources] = useState(null);
    const [selectedSources, setSelectedSources] = useState({});
  
    const [memos, setMemos] = useState(null);
    const [selectedMemos, setSelectedMemos] = useState({});

    const [questions, setQuestions] = useState(null);

    const [prevCommand, setPrevCommand] = useState([]);
    const [commandCount, setCommandCount] = useState(0);

    const [sideBarOpen, setSideBarOpen] = useState(false);
    const [hideSideBar, setHideSideBar] = useState(false);

    const [sideMemoBarOpen, setSideMemoBarOpen] = useState(false);
    const [hideSideMemoBar, setHideSideMemoBar] = useState(false);

    const [personas, setPersonas] = useState([]);

    const [currentModel, setCurrentModel] = useState("gpt-4o");
    const [firstname, setName] = useState("");

    const [tokens_count, setTokensCount] = useState(0);

    const [loadingText, setLoadingText] = useState("Getting things ready...");    

    const [paid, setPaid] = useState(false);
    const [hasStripeID, sethasStripeID] = useState(false);
    const [cur_user, setUser] = useState(null);
    const [CACAuth, setCACAuth] = useState(false);
    const [CUIAuth, setCUIAuth] = useState(false);
  
    const [live, setLive] = useState(0);    

    const [currentChats, setcurrentChats] = useState([]);
    
    const [chatLog, setRChatLog] = useState([]);
    var latest_chatlog = [];

    const [isLoading, setIsLoading] = useState(false);

    const [triggerFilePopup, setTriggerFilePopup] = useState(0);
    const [triggerAddURL, setTriggerAddURL] = useState(0);
    
    function openURLPopup() {
      setTriggerAddURL(1);
    }

    const theme = useTheme();

    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const [current_dataset, setCurrentDataset] = useState(null);

    const [loaded, setLoaded] = useState(false);
    var loaded_static = false;

    const [loaded_main, setLoadedMain] = useState(false);
    var loaded_static_main = false;

    const showSubscribeBanner = ((paid != true && default_data.default_customer_tenant !== true) || (cur_user && cur_user.plan_type && cur_user.plan_type === 'trial'))

    async function deleteSourceR(source_id) {
      await deleteSource(source_id)
      await loadSources()
    }

    async function saveMemo(message) {    
      var content = message;
      if (message.message_orig !== undefined && message.message_orig !== null && message.message_orig !== '') {
        content = message.message_orig;
      }
      var references = JSON.stringify(message.references);
      var references_descriptions = JSON.stringify(message.references_descriptions);
      var type = 'response';
      var title = 'Saved memo';
      await addMemo(workbook.id, title, type, content, references, references_descriptions);
      await loadMemos()
    }

    async function deleteMemoR(memo_id) {
      await deleteMemo(memo_id)
      await loadMemos()
    }

    function setChatLog(value) {
      const newArray = [...value];
  
      latest_chatlog = newArray;
      return setRChatLog(newArray);
    }

    function getTokenWindow() {
      return getTokenWindowR(currentModel)
    }
  
    function isCUICapable() {
      return isCUICapableR(currentModel, live)
    }

    const token_needed = 70000;

    async function get_model_info() {
      return await getModelInfoR(currentModel, token_needed, null)
    }
    
    async function loadChats() {
      setChatLogAndSave([{ user: "gpt", message: `Welcome, how can I help you?`, added_obj: null }], true);
      try {
        if(workbook.chats != null && workbook.chats !== '') {
          var chats = JSON.parse(workbook.chats);
      
          for (const sub_element of chats) {
            if (sub_element.message_orig !== undefined && sub_element.message_orig !== null && sub_element.message_orig !== '') {
              var parsed_message = await parseMessage(random_element, unEscapeHTML(sub_element.message_orig));
              sub_element.message = parsed_message['message'];
              sub_element.images = parsed_message['images'];
            }
            if (sub_element.message !== undefined && sub_element.message !== null && sub_element.message.indexOf('<convert_code>') !== -1) {
              sub_element.message = loadPendingCode(sub_element.message);
            }
            setcurrentChats(chats);
            loadChatLog(chats)
          }
        }    
      } catch (error) {
        log.error(`/workbook: loadChats: ${error.message}`);
        setcurrentChats([]);
      }
    }
    
    function voteDown(uuid) {
      var token = getToken()
      if(token === false) {
        return;
      }
    
      fetch(default_data.default_chat_service_url + '/vote-down', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-tokens': `${token}`
        },        
        body: JSON.stringify({
          uuid: uuid
        })
      })
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('An error occurred while getting data.');
        })
        .then(data => {
          if(data != null && data.status != 200) {            
          }
        })
        .catch(error => {
          log.error(`/workbook: voteDown: ${error.message}`);
        });
    }  

    async function getTokenizer(string) {
      setTokensCount(await getTokenizerR(string))
    } 
        
    useEffect(() => {
        if(loaded || loaded_static) {
          return;
        }

        loadPersonas()

        setLoaded(true)
        loaded_static = true;

        if(getWithExpiry('loss-pass') === true) {
          window.location = '/update?action=force_password';
          return;
        }

        var user = getUser()

        setPaid(user.paid)
        if(user.paid === false) {
          window.location = '/payment';
          return;
        }

        if(user.stripe_customer_id != null && user.stripe_customer_id != '') {
          sethasStripeID(true)
        }
        else {
          sethasStripeID(false)
        }        
        setUser(user)

        setCUIAuth(false)
        if(user.cac_auth && (user.cac_auth === 'true' || user.cac_auth === true)) {
          setCACAuth(true)
          setCUIAuth(true)
        } 
        else {  
          setCACAuth(false) 
          setCUIAuth(false)
        }

        if(user.is_cui_mfa_authorized && user.is_cui_mfa_authorized === true && user.mfa_auth && (user.mfa_auth === 'true' || user.mfa_auth === true)) {
          setCUIAuth(true)
        } 
        
        setName(getName())
    }, [])

    function isCUI(workbook) {
      if(workbook === null) {
        return false;
      }
      if(workbook.classification && workbook.classification === 'CUI') {
        return true;
      }
      return false;
    }

    function getDatasetName(workbook, short=true) {
      var cur_dataset = 'workbook-' + workbook.id
      if(isCUI(workbook)) {
        cur_dataset = 'CUI-workbook-' + workbook.id
      }
      if(short) {
        return cur_dataset
      }
      return 'user_custom_' + workbook.user_id + '_' + cur_dataset + '_content'
    }

    function addDataset(dataset) {  
      var token = getToken()
      if(token === false) {
        return;
      }
  
      if(dataset === null || dataset === '') {
        return;
      }
      if(dataset.length > 100) {
        return;
      }  
      try {
        fetch(default_data.default_user_service_url_no_cac + '/add-dataset', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-access-tokens': `${token}`
          },        
          body: JSON.stringify({
            dataset: dataset,
            classification: workbook.classification
          })
        })
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('An error occurred while getting data.');
        })
        .then(data => {
          var ret = ''
          if(data['status'] === 200) {
            ret = "Dataset created!"
          }
          else if(data['status'] === 404) {
            ret = "Sorry, you have hit the limit of datasets you can create (150), please try again or reach out to our support team for help."
          }
          else if(data['status'] === 405) {
            ret = "Sorry, this dataset already exists."
          }
          else if(data['status'] === 406) {
            ret = "Sorry, this dataset name is too long and must be under 100 characters."
          }
          else if(data['status'] === 407) {
            ret =  "Sorry, you need to logout and login with a CAC to create a CUI dataset."
          }
          else if(data['status'] === 408) {
            ret = "Sorry, your dataset name must be more than 3 characters."
          }
          else if(data['status'] === 409) {
            ret = "Sorry, your dataset name must only be alphanumerical with '-' accepted. Spaces are NOT allowed."
          }
          else {
            ret = "Sorry, internal error, please try again or reach out to our support team for help."
          }
          return ret;
        })       
        .catch(error => {
          return false;
        });      
      } catch (error) {
        return false;
      }          
    } 

    function loadPersonas() {
      var token = getToken()
      if(token === false) {
          logout()        
          return;
      }
    
      fetch(default_data.default_chat_service_url + '/get-personas', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-tokens': `${token}`
        },        
        body: JSON.stringify({
        })
      })
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('An error occurred while getting data.');
        })
        .then(data => {
          var res = data.response;
          if(data != null && data.status == '200') {            
            res.sort((a, b) => {
              const nameA = a['name'].toUpperCase();
              const nameB = b['name'].toUpperCase();
              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }
              return 0;
            });
            setPersonas(res)
          }
          else if(data != null && data.status == '400') {
            if(data.response.indexOf('Token is invalid') > -1) {
              logout()
            }
          }            
        })
        .catch(error => {
          log.error(`/workbook: loadPersonas: ${error.message}`);
        });
    }  

    async function loadSources() {
      try {
        var token = getToken()
        if(token === false) {
          return null;
        }
    
        var user = getUser()
    
        if(user === false || user == null) {
          window.location = '/login';
        }

        const response = await fetch(default_data.default_user_service_url_no_cac + '/get-sources', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-access-tokens': `${token}`
          },        
          body: JSON.stringify({
            workbook_id: workbook.id
          })
        })
        const data = await response.json();

        if(data.status != 200) {
            return null;
        }
        setSources(data.response);
        return data.response;
      }
      catch (error) {
        log.error(`/workbook: loadSources: ${error.message}`);
        return null;
      }
    }

    async function loadMemos() {
      try {
        var token = getToken()
        if(token === false) {
          return null;
        }
    
        var user = getUser()
    
        if(user === false || user == null) {
          window.location = '/login';
        }

        const response = await fetch(default_data.default_user_service_url_no_cac + '/get-memos', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-access-tokens': `${token}`
          },        
          body: JSON.stringify({
            workbook_id: workbook.id
          })
        })
        const data = await response.json();

        if(data.status != 200) {
            return null;
        }
        setMemos(data.response);
        return data.response;
      }
      catch (error) {
        log.error(`/workbook: loadMemos: ${error.message}`);
        return null;
      }
    }


    async function loadQuestions(sources, memos) {
      try {
        var token = getToken()
        if(token === false) {
          return null;
        }
    
        var user = getUser()

        setQuestions(null);
        if(user === false || user == null) {
          window.location = '/login';
        }

        var source_content = getFilteredSourceContent(sources)
        var memo_content = getFilteredMemoContent(memos)

        var new_message = "CONTEXT PROVIDED:\n" + source_content + "\n\n" + memo_content + "\nEND OF CONTEXT.\nBased on the context provided, provide a <ul> HTML list of three next logical questions the Human should ask you related to the context. Make sure the answers to the questions are present in the context or pick another question. Only respond with the ul list.";

        var model_info = await get_model_info()
        var new_model = model_info.model
   
        const formData = new FormData();
        formData.append('message', new_message);
        formData.append('model', new_model);
        formData.append('dataset', "none");
        formData.append('streaming', false);

        const response = await fetch(default_data.default_chat_service_url + '/query', {
          method: 'POST',
          headers: {
            'x-access-tokens': `${token}`
          },        
          body: formData,
          timeout: 1200000 // 20 minutes in milliseconds
        })
        const data = await response.json();
        if(data.status != 200) {
          if(data.response.indexOf('Token is invalid') !== -1) {
            return;
          }
          else {
            log.error(`/workbook: loadQuestions: ${data}`);
            return;
          }
        }
        else {
          var follows = []
          var message = data.message;
          if(message.indexOf('<li>') !== -1) {
            // Loop through each <li> element and display its value            
            const li_regex = /<li>([\s\S]*?)<\/li>/g;
            const matches = message.match(li_regex);
            matches.forEach(li => {
              follows.push(li.replace('<li>', '').replace('</li>', ''));
            });
          }
          else if(message.indexOf('- ') !== -1) {
            const itemsArray = message.split("- ");
            itemsArray.forEach((element) => {
              element = strip(element);
              if(element != '') {
                follows.push(element)
              }
            });
          }
          else if(message.indexOf('1.') !== -1) {
            const itemsArray = message.split("\n")            
            itemsArray.forEach((element) => {
              element = strip(element);
              var numRegEx = /\d+\.\s/
              if(element != '' && numRegEx.test(element)) {
                var index = element.indexOf(' ');
                element = element.substring(index + 1)                
                follows.push(element)
              }
            });
          }
          else if(message.indexOf('?') !== -1) {            
            let itemsArray = message.split("\n");
            itemsArray.forEach((element) => {
              element = strip(element);
              if(element != '' && element.indexOf('?') !== -1) {
                follows.push(element)
              }
            });
          }

          var should_fail = false;
          follows.forEach((element) => {
            if(element.toLowerCase().indexOf('anything else you would like to know') !== -1) {
              should_fail = true;        
            }
            else if(element.toLowerCase().indexOf('can help you with') !== -1) {
              should_fail = true;        
            }
            else if(element.toLowerCase().indexOf('can i help you with') !== -1) {
              should_fail = true;        
            }
            else if(element.toLowerCase().indexOf('have any other question') !== -1) {
              should_fail = true;        
            }
            else if(element.toLowerCase().indexOf('would you like to know') !== -1) {
              should_fail = true;        
            }
            else if(element.toLowerCase().indexOf('i apologize') !== -1) {
              should_fail = true;        
            }
            else if(element.toLowerCase().indexOf('made a mistake') !== -1) {
              should_fail = true;        
            }
          });

          if(should_fail) {
            return;
          }
          else {
            if(follows.length > 0) {
              setQuestions(follows)
            }
          }            
        }
      }
      catch (error) {
        log.error(`/workbook: loadQuestions: ${error.message}`);
        return null;
      }
    }

    async function generateOverallSummary(sources) {
      try {
        var token = getToken()
        if(token === false) {
          return null;
        }
    
        var user = getUser()

        if(user === false || user == null) {
          window.location = '/login';
        }

        var source_content = getFilteredSourceContent(sources)

        if(source_content === null || source_content === '') {
          return;
        }

        var prompt_template = "Write a detailed summary of the provided text, focusing on the main points. Do not include any introductory phrases. Never use phrases like \"the text is about\". Ensure the summary is concise and effectively communicates the key points of the content:\n" + source_content;

        var model_info = await get_model_info()
        var new_model = model_info.model
   
        const formData = new FormData();
        formData.append('message', prompt_template);
        formData.append('model', new_model);
        formData.append('dataset', "none");
        formData.append('streaming', false);

        const response = await fetch(default_data.default_chat_service_url + '/query', {
          method: 'POST',
          headers: {
            'x-access-tokens': `${token}`
          },        
          body: formData,
          timeout: 1200000 // 20 minutes in milliseconds
        })
        const data = await response.json();

        if(data.status != 200) {
          if(data.response.indexOf('Token is invalid') !== -1) {
            return;
          }
          else {
            return;
          }
        }
        else {
          if(data['status'] === 200) {
            var summary = data['message'];
            workbook.overall_summary = summary;
            saveOverallSummary(summary)
          }
        }
      }
      catch (error) {
        log.error(`/workbook: generateOverallSummary: ${error.message}`);
        return null;
      }
    }

    function saveOverallSummary(summary) {
      var token = getToken()
      if(token === false) {
        return;
      }
      try {
        fetch(default_data.default_user_service_url_no_cac + '/workbook-summary', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-access-tokens': `${token}`
          },
          body: JSON.stringify({
            overall_summary: summary,
            workbook_id: workbook.id
          })
        })
          .then(response => {
            if (response.ok) {
              return response.json();
            }
            throw new Error('An error occurred while sending summary.');
          })
          .then(data => {
            if(data.status != 200) {
            }
          })
          .catch(error => {
            log.error(`/workbook: saveOverallSummary: ${error.message}`);
          });
      }
      catch {}
    }


    useEffect(() => {
      if(loaded_main || loaded_static_main) {
        return;
      }

      const fetchData = async () => {
        if (workbook === null) {
          window.location = '/workbook';
          return;
        }

        setIsLoading(true)

        try {
      
          setSources(null);

          var model_first = await proposeModelCount(token_needed);
          if(model_first !== null) {
            setCurrentModel(model_first)
          }
      
          const dataset_long = getDatasetName(workbook, false);
          const dataset_short = getDatasetName(workbook, true);
          addDataset(dataset_short);
          setCurrentDataset(dataset_long);
      
          await loadChats()

          const memos = await loadMemos();

          const cur_sources = await loadSources();
          if (cur_sources === null || cur_sources.length === 0) {
            setTriggerFilePopup(1);
          }
          else {
            if(workbook.overall_summary === null || workbook.overall_summary === '' || workbook.overall_summary === undefined) {
              await generateOverallSummary(cur_sources)
            }
            await loadQuestions(cur_sources)
          }

          setIsLoading(false)
        }
        catch (error) {
          log.error(`/workbook: fetchData: ${error.message}`);
          setIsLoading(false)
        }
      };
    
      setLoadedMain(true)
      loaded_static_main = true;
      fetchData();

    }, [workbook]);

  // clear chats
  function clearChat(){
    setChatLogAndSave([{ user: "gpt", message: `Welcome, how can I help you?`, added_obj: null }], false);
  }

  function newChat(){
    setChatLogAndSave([{ user: "gpt", message: `Welcome, how can I help you?`, added_obj: null}], false)
  }
  var random_element = document.createElement('div');

  function loadChatLog(chats) {
    if(chats.length === 0) {
      return setChatLog([{ user: "gpt", message: `Welcome, how can I help you?`, added_obj: null}])
    }
    else {
      if(chats != null) {
        setChatLog(chats)
      }        
    }
  }

  function saveChats(chats) {
    var token = getToken()
    if(token === false) {
      return;
    }
    try {
      workbook.chats = JSON.stringify(chats);
      fetch(default_data.default_user_service_url_no_cac + '/workbook-chats', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-access-tokens': `${token}`
          },   
          body: JSON.stringify({
            chats: chats,
            workbook_id: workbook.id
          })
        })
          .then(response => {
            if (response.ok) {
              return response.json();
            }
            throw new Error('An error occurred while sending chats.');
          })
          .then(data => {
            if(data.status != 200) {
            }
          })
          .catch(error => {
  
          });
    }
    catch {}
  }
    
  function setChatLogAndSave(chatLog, no_save=false) {
    setChatLog(chatLog)

    if(no_save === false) {
      saveChats(chatLog)
    }
    return chatLog
  }

  function addReferences(index_id, data, max_size=250) {

    if(data.references == null || data.references == '') {
      return;
    }
  
    var references = data.references 
    var references_array = []
    var references_descriptions = [] // New array to store descriptions
  
    // List of delimiters
    var delimiters = [
      ' - Video Description:',
      ' - Summary:',
      ' - Data:',
      ' - Article:',
      ' - Article Description:',
      ' - Content:',
      ' - Sage:'
    ];
    
    let refArray = references.split("\n");
    refArray.forEach((element) => {
      element = strip(element);
      var index = -1;
      var description = ''; // Variable to store description
      if(element != '') {
        // Iterate over delimiters
        for (let delimiter of delimiters) {
          if (element.indexOf(delimiter) !== -1) {
            index = element.indexOf(delimiter);
            description = element.substring(index + delimiter.length); // Store description
            element = element.substring(0, index);
            break; // Break the loop as soon as a delimiter is found
          }
        }
        if(index === -1) {
          if(element.length > max_size) {
            description = element;
            element = element.substring(0, max_size) + '...';
          }
          else {
            description = ''; // If no delimiter is found, description is empty
          }
        }
        references_array.push(urlify(escapeHTML(element)))
        references_descriptions.push(escapeHTML(description)); // Push description to array        
      }
    });
    
    var i = 1;
    var res_references = []
    var res_references_descriptions = []
    while(i <= 20) {
      if(data.message.indexOf('[' + i.toString() + ']') !== -1) {
        references_array.forEach((element) => {
          if(element.indexOf('[' + i.toString() + ']') !== -1) {
            res_references.push(element)
            res_references_descriptions.push(references_descriptions[references_array.indexOf(element)])
          }
        });
      }
      i++;
    }
    var found = findChatLogIndexAndUpdate(index_id, {references: res_references, references_descriptions: res_references_descriptions});
    if(found === true) {
      setChatLogAndSave(latest_chatlog, true)
    }    
  }

  function findChatLogIndexAndUpdate(index_id, array_values, append_message=false) {    
    var found_element = false;
    latest_chatlog.forEach((element) => {
      if(element['id'] == index_id) {
        for (var field in array_values) {
          if(append_message === true && field === 'message') {
            element[field] = element[field].replace(get_loading_message(), '');
            element[field] += array_values[field];    
          }
          else {
            element[field] = array_values[field];
          }
        }
        found_element = true;
      }
    });
    return found_element;
  }

  async function getFollowUps(index_id){
    try {
      var token = getToken()
      if(token === null) {

        window.location = '/login';
      }
      var output = trimChatHistoryByCount(latest_chatlog, null, 10)

      var model = await proposeModelCount(2000, null, true)

      var error = false;
      const response = await fetch(default_data.default_chat_service_url + '/follow-up-questions', {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'x-access-tokens': `${token}`        
        },
        body: JSON.stringify({
          message: output,
          model: model,
          dataset: current_dataset
        })
        }).catch(err => {
          error = true
          console.log(err);
        });      
      if(error === true) {
      }
      else {
        const data = await response.json();
        if(data.status != 200) {
          if(data.response.indexOf('Token is invalid') !== -1) {
            return;
          }
          else {
            console.log(data)
            return;
          }
        }
        else {
          var follows = []
          var message = data.message;
          if(message.indexOf('<li>') !== -1) {
            // Loop through each <li> element and display its value            
            const li_regex = /<li>([\s\S]*?)<\/li>/g;
            const matches = message.match(li_regex);
            matches.forEach(li => {
              follows.push(li.replace('<li>', '').replace('</li>', ''));
            });
          }
          else if(message.indexOf('- ') !== -1) {
            const itemsArray = message.split("- ");
            itemsArray.forEach((element) => {
              element = strip(element);
              if(element != '') {
                follows.push(element)
              }
            });
          }
          else if(message.indexOf('1.') !== -1) {
            const itemsArray = message.split("\n")            
            itemsArray.forEach((element) => {
              element = strip(element);
              var numRegEx = /\d+\.\s/
              if(element != '' && numRegEx.test(element)) {
                var index = element.indexOf(' ');
                element = element.substring(index + 1)                
                follows.push(element)
              }
            });
          }
          else if(message.indexOf('?') !== -1) {            
            let itemsArray = message.split("\n");
            itemsArray.forEach((element) => {
              element = strip(element);
              if(element != '' && element.indexOf('?') !== -1) {
                follows.push(element)
              }
            });
          }

          var should_fail = false;
          follows.forEach((element) => {
            if(element.toLowerCase().indexOf('anything else you would like to know') !== -1) {
              should_fail = true;        
            }
            else if(element.toLowerCase().indexOf('can help you with') !== -1) {
              should_fail = true;        
            }
            else if(element.toLowerCase().indexOf('can i help you with') !== -1) {
              should_fail = true;        
            }
            else if(element.toLowerCase().indexOf('have any other question') !== -1) {
              should_fail = true;        
            }
            else if(element.toLowerCase().indexOf('would you like to know') !== -1) {
              should_fail = true;        
            }
            else if(element.toLowerCase().indexOf('i apologize') !== -1) {
              should_fail = true;        
            }
            else if(element.toLowerCase().indexOf('made a mistake') !== -1) {
              should_fail = true;        
            }
          });

          if(should_fail) {
            return;
          }
          var found = false;
          latest_chatlog.forEach((element) => {
            if(element['id'] == index_id) {
              element['follows'] = follows;
              found = true;
            }
          });
          if(found) {
            setChatLogAndSave(latest_chatlog, false)
            scrollToBottom();
          }            
        }
      }
    }
    catch (error) {
      console.error(error);
    }
  }

  const handleLive = (event) => {
    setLive(parseInt(event.target.value));
  };

  function clickHandlerFollowUp(e, setChatInput) {
    var value = e.target.textContent;
    if(value != '') {
      submitPrompt(value, setChatInput)
      e.target.disabled = true;
    }
  }

  function clickHandlerCopy(e) {
    let el = e.target;
    while (el && el !== e.currentTarget && el.tagName !== "BUTTON") {
        el = el.parentNode;
    }
    var uuid = el.getAttribute('tag');
    if(uuid != '' && uuid != null) {
      var found = false;
      var content = '';
      chatLog.forEach((element) => {
        if(element['id'] == uuid) {
          content = unEscapeHTML(element['message_orig'])
          found = true;
        }
      });
      if(found) {
        el.classList.add('clicked');
        setTimeout(() => {
          el.classList.remove('clicked');
        }, 2000);
        navigator.clipboard.writeText(content);
      }          
      else {
        console.log('not found')
      }
    }
  }

  function clickHandlerEdit(id, message, setChatInput) {
    if(id != '' && id != null) {
      chatLog.forEach((element, index) => {
        if(element['id'] == id) {
          const truncatedChatLog = chatLog.slice(0, index);
          setChatInput(unEscapeHTML(message))
          setChatLogAndSave(truncatedChatLog, false);        
          return;
        }        
      });
    }
  }

  function clickHandlerDown(id) {
    if(id != '' && id != null) {
      var found = false;
      chatLog.forEach((element) => {
        if(element['id'] == id) {
          found = true;
        }
      });
      if(found) {
        voteDown(id)
      }          
      else {
        console.log('not found')
      }
    }
  }

  function clickHandlerDelete(item) {
    if(item != '' && item != null) {
      // if item is string, search by ['id']
      if(typeof item === 'string') {
        // Filter the chatLog array to exclude the item with the specified uuid
        const updatedChatLog = chatLog.filter(element => element['id'] !== item);
        // Update the chatLog and save the updated list
        setChatLogAndSave(updatedChatLog, false);
      }
      else {
        const updatedChatLog = chatLog.filter(element => element !== item);
        setChatLogAndSave(updatedChatLog, false);
      }
    }
  }

  function get_loading_message() {
    return `<img class=${theme.palette.mode === 'dark' ? "spinner" : 'spinner-dark'} src="spinner.png" alt="Loading..."> I'm thinking, please wait...`;
  }

  async function handleSubmit(e, chatInput, setChatInput){
    e.preventDefault();
    submitPrompt(chatInput, setChatInput)
  }  

  async function handleResponseStream(chatLogNew, response) {
    
    const reader = response.body.getReader();
      
    const decoder = new TextDecoder('utf-8'); // Create a TextDecoder instance

    let bufferLeft = ''

    while(true) {
      const {value, done} = await reader.read();
      try {
        if(value === undefined) {
          // check if bufferLeft not empty and if starts and ends with {
          if (bufferLeft !== '' && bufferLeft.startsWith('{')) {
            try {
              var http_response = JSON.parse(bufferLeft);
              if(http_response.status !== 200 && http_response.status !== '200') {
                log.error(`/query_stream: Error 601: ${bufferLeft}`);
                setChatLogAndSave([...chatLogNew, { user: "gpt", message: `Error: please try again - the model servers are overloaded or your connection is unstable. If you are getting this error continuously, please try to start a new chat by typing /new or clicking on New Chat in the menu (top left) or reach out to us. [ERROR: 601]`, added_obj: null, type_auth: getTypeAuth() }], false);
              }
            }
            catch (error) {
              log.error(`/workbook: handleResponseStream: ${error.message}`);
              log.error(`/workbook: handleResponseStream: ${error.stack}`);
            }
          }
          return;
        }
        if (done) {
          if(bufferLeft !== '') {
            var ret2 = await handleData(chatLogNew, bufferLeft);
            if(ret2 === null) {
              setChatLogAndSave([...chatLogNew, { user: "gpt", message: `Error: please try again - the model servers are overloaded or your connection is unstable. If you are getting this error continuously, please try to start a new chat by typing /new or clicking on New Chat in the menu (top left) or reach out to us. [ERROR: 101]`, added_obj: null, type_auth: getTypeAuth() }], false);
            }
            bufferLeft = ''
          }
          break;
        } 
        var tmp_text = decoder.decode(value); // Decode the Uint8Array into a string

        var cur_items_text = bufferLeft + tmp_text;

        if(cur_items_text.indexOf('@|@sep@|@') !== -1) {
          var cur_items = cur_items_text.split('@|@sep@|@'); // Split the chunk into lines
          for (const cur_item of cur_items) {
            if(cur_item !== '') {
              var err = await handleData(chatLogNew, cur_item);
              if(err === null) {
                bufferLeft += cur_item;
              }
              else {
                bufferLeft = '';
              }
            }
          }  
        }
        else {
            bufferLeft = cur_items_text;
        }        
      }            
      catch(error) {
        log.error(`/query_stream: Error 1: ${error.message}`);
        log.error(`/query_stream: Error stack 2: ${error.stack}`);
      }
    }    
  }

  function handleAudio(blob, chatInput, setChatInput) {
    // Send the Blob to the API
    if (validateFile(blob)) {
      var token = getToken();
      if(token === false) {
        return;
      }

      setIsLoading(true);
      setLoadingText('Please wait, loading...');

      const formData = new FormData();
      formData.append('file', blob, 'audio.mp4'); // Add the Blob to the form data
      formData.append('strategy', 'auto');

      try {
        fetch(default_data.default_chat_service_url_files + '/file', {
          method: 'POST',
          headers: {
            'x-access-tokens': `${token}`,
            'Connection': 'keep-alive' // Add this line
          },        
          body: formData,
          timeout: 1200000 // 20 minutes in milliseconds
        })
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('An error occurred while getting data.');
        })
        .then(data => {
          var ret = 'Internal error, please contact customer support with more information about your file'
  
          if(data['status'] == '200') {
            if(typeof data['ret'] === 'object') {
              if('text' in data['ret']) {
                ret = removeMetadata(data['ret'].text);
              }
              else {
                ret = 'Internal error, please contact customer support with more information about your file [2]'
              }
            }
            else {
              ret = removeMetadata(data['ret'])
            }
          }
          else if(data['response'] === 'No file too large') {
            ret = 'File too large, please contact customer support with more information about your file'
          }           
          else if(data['response'] === 'Virus detected in file') {
            ret = 'Virus detected in file, please contact customer support with more information about your file'
          }           
          else if(data['response'] === 'File type not allowed') {
            ret = 'File type not allowed, please contact customer support with more information about your file'
          }
          if(chatInput.length > 0) {
            setChatInput(chatInput + '\n' + ret)
          }
          else {
            setChatInput(ret)
          }
          setIsLoading(false);  
      })
      .catch(error => {
        setIsLoading(false);
        console.log(error);
      });  
      }
        catch (error) {
        setIsLoading(false);
        console.log(error)
      }
    }
  }

  async function submitPrompt(input_obj, setChatInput, force_full=true) {
    try {
      var token = getToken()
      if(token === null) {
        logout()
        return;
      }

      var unescaped_input = input_obj;
      var escaped_input = escapeHTML(input_obj)
                  
      if(escaped_input == '') {
        return;
      }

      if(escaped_input.toLowerCase() === '/clear') {
        clearChat()
        if(setChatInput !== undefined) {
          setChatInput("");
        }
        return;
      }
      if(escaped_input.toLowerCase() === '/new') {
        newChat()
        if(setChatInput !== undefined) {
          setChatInput("");
        }
        return;
      }

      let prevCommandNew = [...prevCommand, unescaped_input]
      setPrevCommand(prevCommandNew);
      setCommandCount(commandCount + 1);

      var index_new_me_message = uuidv4();
      let chatLogNew = [...chatLog, { user: "me", id: index_new_me_message, file: null, message: escaped_input, added_obj: null, type_auth: getTypeAuth()} ]

      var model_info = await get_model_info()
      var new_model = model_info.model
      var history_count = model_info.history_count

      var output = trimChatHistoryByCount(chatLogNew, null, history_count)
      let chatLogNew2 = [...chatLogNew, { user: "gpt", message: get_loading_message(), added_obj: null} ]
      if(setChatInput !== undefined) {
        setChatInput("");
      }
      setChatLogAndSave(chatLogNew2, true)

      var selected_dataset = current_dataset

      var forced_live = live
      if(isBotLoggedIn() && getBotSettingItem('force_live') !== null) {
        forced_live = getBotSettingItem('force_live')
      }
      if(force_full === 'memo_only') {
        forced_live = 0;
      }

      if((force_full === true || force_full == 'memo_only') && forced_live === 0) {
        // get last question, format with context from all sources, check getTokenizer is under 80,000 and submit to model 
        var last_message = output[output.length - 1];

        var source_content = getFilteredSourceContent(selectedSources) + "\n\n";

        if(force_full === 'memo_only') {
          source_content = '';
        }

        var memo_content = getFilteredMemoContent(selectedMemos)

        if(force_full === 'memo_only') {
          if(memo_content === '') {
            setChatLogAndSave([...chatLogNew, { user: "gpt", message: `Sorry, you need to select at least one memo to continue.`, added_obj: null, type_auth: getTypeAuth() }], false);
            return;
          }
        }

        var new_message = "CONTEXT PROVIDED:\n" + source_content + memo_content + "\nEND OF CONTEXT.\nBased on the context provided, answer the following question:\n" + last_message.message

        var new_message_tokens = await getTokenizerR(new_message)
        if (new_message_tokens < 80000) {
          // replace message in output          
          output[output.length - 1].message = new_message
          //selected_dataset = "none"
        }

        if(force_full === 'memo_only') {
          selected_dataset = "none";
        }
      }

      scrollToBottom();      

      const streamResults = async () => {  
        try {
          const formData = new FormData();
          formData.append('message', JSON.stringify(output));
          formData.append('model', new_model);
          formData.append('dataset', selected_dataset);
          formData.append('live', forced_live);
          formData.append('streaming', true);

          const response = await fetch(default_data.default_chat_service_url + '/query', {
            method: 'POST',
            headers: {
              'x-access-tokens': `${token}`
            },
            body: formData,
            timeout: 1200000 // 20 minutes in milliseconds
          });
          
          if (!response.ok) {
            log.error(`/query_stream: Response Status: ${response.status}`);
            log.error(`/query_stream: Response Headers: ${JSON.stringify(response.headers)}`);        
            throw new Error(`HTTP error! status: ${response.status}`);
          }      
          await handleResponseStream(chatLogNew, response)
        }
        catch (err) {
          if (!err.message) {
            setChatLogAndSave([...chatLogNew, { user: "gpt", message: `Error: please try again - the model servers are overloaded or your connection is unstable. If you are getting this error continuously, please try to start a new chat by typing /new or clicking on New Chat in the menu (top left) or reach out to us. [ERROR: 101]`, added_obj: null, type_auth: getTypeAuth() }], false);
          } else {
            log.error(`/query_stream: Error: ${err.message}`);
            log.error(`/query_stream: Fetch error stack: ${err.stack}`); // Log the error stack trace
            setChatLogAndSave([...chatLogNew, { user: "gpt", message: `Error: please try again - the model servers are overloaded or your connection is unstable. If you are getting this error continuously, please try to start a new chat by typing /new or clicking on New Chat in the menu (top left) or reach out to us. [ERROR: 202]`, added_obj: null, type_auth: getTypeAuth() }], false);
          }
        }
      }
  
      streamResults();
    }
    catch (error) {
      log.error(`/workbook: submitPrompt: ${error.message}`);
      log.error(`/workbook: submitPrompt: ${error.stack}`);
    }
  }

  async function handleData(chatLogNew, ret, log_error=false) {
    var data = null;
    try {
      try {
        data = JSON.parse(ret);
      }
      catch(err) {
        if(log_error) {
          log.error(`/workbook: handleData: ${ret}`);
          log.error(`/workbook: handleData: ${err.message}`);
        }
        return null;
      }
      if(data === null) {
        return null;
      }
      var index_new_message = uuidv4();
      if(data.uuid != null && data.uuid != '') {
        index_new_message = data.uuid;
      }
      
      if(data.message !== '' && data.message != null) {    
        if (Array.isArray(data.message)) {
          data.message = data.message.join('\n');
        }
        data.message = data.message.replace(' Source: ', "\n\nSource: ");
        data.message = data.message.replace(' Sources: ', "\n\nSources: ");
        data.message = data.message.replace(' Reference: ', "\n\nReference: ");
        data.message = data.message.replace(' References: ', "\n\nReferences: ");
        data.message = data.message.replace(' Reference 1: ', "\n\nReference 1: ");
        data.message = data.message.replace('.Reference: ', ".\n\nReference: ");
        data.message = data.message.replace('.References: ', ".\n\nReferences: ");
        data.message = data.message.replace('.Reference 1: ', ".\n\nReference 1: ");
        data.message = data.message.replace('Reference: 1.', "Reference:\n1.");
        data.message = data.message.replace('References: 1.', "References:\n1.");

        data.message_orig = data.message;

        var ret_parse = await parseMessage(random_element, data.message);
        data.message = ret_parse['message'];
        data.images = ret_parse['images'];

        data.added_obj = JSON.stringify(data.added_obj);

        if(data.type === 'yield') {
          data.message += "\n\n" + get_loading_message();
        }

        var chat_log_update_obj = {message: data.message, file: data.file, embedding_down: data.embedding_down, vectors_down: data.vectors_down, added_obj: data.added_obj, analysis_failed: false, type: data.type, images: data.images}
        if(data.type !== 'yield') {
          chat_log_update_obj['message_orig'] = data.message_orig
        }
        var cur_chat_log = findChatLogIndexAndUpdate(index_new_message, chat_log_update_obj, true)
        if(cur_chat_log === false) {
          setChatLogAndSave([...chatLogNew, { id: index_new_message, user: "gpt", message_orig: `${data.message_orig}`, message: `${data.message}`, embedding_down: `${data.embedding_down}`, vectors_down: `${data.vectors_down}`, added_obj: `${data.added_obj}`, analysis_failed: false, references:null, references_descriptions: null, type: data.type, type_auth: getTypeAuth(), images: `${data.images}`}], false)
        }
        else {
          setChatLogAndSave(latest_chatlog, false)
        }
        if(data.type !== 'teach' && data.type !== 'yield') {
          if(data.images) {

          }
          else {
            addReferences(index_new_message, data)
            getFollowUps(index_new_message)
          }
        }
      }
      else {
        setChatLogAndSave([...chatLogNew, { user: "gpt", message: `Sorry, please try a different prompt - No answer.`, added_obj: null, type_auth: getTypeAuth()} ], true)
      }        
      scrollToBottom();        
      return true;
    }
    catch (error) {
      log.error(`/workbook: handleData: ${error.message}`);
      log.error(`/workbook: handleData: ${error.stack}`);
      return null;
    }
  }

  function loadPendingCode(message) {
    var body = null;
  
    if(message.indexOf('</convert_code>') !== -1) {
      message = message.replace(/<br \/>/g, '\n');
  
      let parser = new DOMParser();
      const doc = parser.parseFromString(message, 'text/html');
  
      var codes = doc.getElementsByTagName('convert_code');
      [...codes].forEach((code) => {
        // horizontal scroll if too long
        var code_inner = code.innerHTML;
  
        random_element.innerHTML = code_inner;              
        code_inner = random_element.textContent;        
        code_inner = window.hljs.highlightAuto(code_inner).value
  
        // Create a new 'code' element and copy the contents of 'convert_code' into it
        const newCode = document.createElement('code');
        newCode.innerHTML = code_inner;
  
        const div = document.createElement('pre');
        div.className = "code_pre"
        const parent = code.parentElement;
  
        if(parent != null) {
          // Replace the 'convert_code' element with the new 'code' element
          parent.replaceChild(div, code);
          div.appendChild(newCode);  
          const copyButton = document.createElement('button');
          copyButton.className = "code_button";
          copyButton.innerText = 'Copy';  
          // Append the copy button to the <code> tag
          div.appendChild(copyButton);  
        }
        else {
        }
      });
      body = doc.getElementsByTagName('body');
      if(body.length != 0) {
        message = body[0].innerHTML;
      }
      else {
        message = doc.documentElement.innerHTML;
      }
      return message;            
    }
  }
  
  function getTypeAuth() {
    var type = 'non-cac';
    if(CACAuth === true) {
      type = 'cac';
    }
    return type;
  }

  function setChatLogAndSaveWithScroll(obj) {
    obj['type_auth'] = getTypeAuth()
    setChatLogAndSave([...chatLog, obj ])
    scrollToBottom()
  }

  const loading_styles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'rgba(0, 0, 0, 0.9)', // Adjust the opacity as needed
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999, // Adjust the z-index as needed to ensure it appears above other elements
    },
    loadingText: {
      color: '#fff',
      fontSize: '24px',
    },
  };

  const [detailsOpen, setDetailsOpen] = useState(false);

  const handleBackClick = () => {
    window.location = '/workbook';
  };

  const handlePromptClick = (key, memo_only=false) => {
    if(key === "bluf" || key === "insights" || key === "toc" || key === "executive_brief" || key === "quiz" || key === "related_ideas" || key === "summarize" || key === "outline" || key === "combine") {
      var input_obj = "";
      
      if(key === "bluf") {
        input_obj = "Please generate a BLUF (Bottom Line Up Front) summary of the context provided. The BLUF should be concise, capturing the main points and key takeaways in a few sentences.";
      }
      else if(key === "insights") {
        input_obj = "Please generate insights from the context provided. The insights should highlight key points, trends, implications, and any actionable recommendations.";
      }
      else if(key === "toc") {
        input_obj = "Please generate a Table of Contents (TOC) based on the context provided. The TOC should outline the main sections and topics covered in the document.";
      }
      else if(key === "executive_brief") {
        input_obj = "Please generate an Executive Brief based on the context provided. The Executive Brief should provide a high-level summary of the document, key findings, and recommendations.";
      }
      else if(key === "quiz") {
        input_obj = "Please generate a quiz based on the context provided. The quiz should include questions that test the reader's understanding of the content and key concepts. Each question should be followed by multiple-choice options (A, B, C, D) and the correct answer should be indicated at the end of the quiz.";
      }
      else if(key === "related_ideas") {
        input_obj = "Please generate related ideas based on the context provided. The related ideas should explore new concepts, connections, or applications related to the content.";
      }
      else if(key === "summarize") {
        input_obj = "Please summarize the context provided. The summary should capture the main points, key details, and essential information in a concise format.";
      }
      else if(key === "outline") {
        input_obj = "Please generate an outline based on the context provided. The outline should organize the content into main sections, subtopics, and key points.";
      }
      else if(key === "combine") {
        input_obj = "Please combine the context provided into a single coherent document. The combined document should flow logically and integrate the main ideas, themes, and information from the context.";
      }
      var full_text = true;
      if(memo_only === true) {
        full_text = 'memo_only';
      }
      submitPrompt(input_obj, undefined, full_text);
    }
    else {
      submitPrompt(key, undefined);
    }
    setDetailsOpen(false);
    // debug move prompt
  }

  const handleDetailsClick = () => {
    setDetailsOpen(true);
  };

  const hasShareAccess = () => {
    if(cur_user === null || cur_user === undefined) {
      return false;
    }
    if(workbook.user_id === cur_user.id) {
      return true;
    }
    if(isAdminLoggedIn() === true) {
      return true;
    }
    return false;
  };

  const handleCloseDetails = () => {
    setDetailsOpen(false);
  };

  const [triggerShare, setTriggerShare] = useState(false);
  const handleShareClick = () => {
    setTriggerShare(true);
  };

  Modal.setAppElement('#root');


  return (
  <div className="AppContainer">
    {
      (CUIAuth === true) ?
      <div className={`header-message ${getBannerColor(CUIAuth)}`}>
        { default_data.default_banner_override != null && default_data.default_banner_override != '' ?
            default_data.default_banner_override : 'CUI'
        }
      </div>
      :
      <div className={`header-message ${getBannerColor(CUIAuth)}`}>
        { default_data.default_banner_override != null && default_data.default_banner_override != '' ?
            default_data.default_banner_override : 'UNCLASSIFIED'
        }
      </div>
    }
    {
      showSubscribeBanner && (
        <div className="header_subscribe">
          <a href="/payment">{default_data.default_subscribe_banner_text}</a>
        </div>
      )
    }
    <div className="workbook-menu">
      <IconButton size='small' onClick={handleBackClick}>
        <FiArrowLeft color='white' />
      </IconButton>
      <span>Workbook - {workbook.title} [{workbook.id}] {  default_data.default_hide_cac !== true && workbook.classification && (
          <Chip label={workbook.classification} color="success" size='small'  />
        )}</span>

      { sources && sources.length > 0 ? 
      <Button onClick={handleDetailsClick} variant="text" size="small" className="link-button">
        Workbook details
      </Button> : <div />}
    </div>
    <Stack 
      direction={ isMobile ? 'column' : 'row' }
      sx={{
        width: '100vw',
        height: `calc(100dvh - ${showSubscribeBanner ? '100px' : '64px'})`, 
        backgroundColor: theme.palette.appBackground,
      }}
    >
      {isMobile && (
        <Stack direction={'row'} justifyContent={'space-between'}>
          <IconButton onClick={()=>{setSideBarOpen(true)}} >
            <FiMenu size={24} />
          </IconButton>
          <div>
            <a href="/dashboard"><img src="logo-menu.png" alt="Ask Sage"/></a>
          </div>
          <Box width={50}></Box>
        </Stack>
      )}
      
      {!isMobile && (
        <Navbar />
      )}
      <div 
        style={{
          display: 'flex',
          width: '100%',
        }}
      >
          <SideMenu
            workbook={workbook}
            sources={sources}
            selectedSources={selectedSources}
            setSelectedSources={setSelectedSources}
            deleteSource={deleteSourceR}
            setSideBarOpen={setSideBarOpen}
            sideBarOpen={sideBarOpen}
            hideSideBar={hideSideBar}
            setHideSideBar={setHideSideBar}
            setTriggerFilePopup={setTriggerFilePopup}
          />
          <ChatBox
            saveMemo={saveMemo}
            handleAudio={handleAudio}
            currentModel={currentModel}
            chatLog={chatLog} 
            cur_user={cur_user}
            live={live}
            paid={paid}
            current_dataset={current_dataset}
            handleLive={handleLive}
            clickHandlerFollowUp={clickHandlerFollowUp}
            clickHandlerCopy={clickHandlerCopy}
            clickHandlerDelete={clickHandlerDelete}
            clickHandlerDown={clickHandlerDown}
            clickHandlerEdit={clickHandlerEdit}
            tokens_count={tokens_count}
            getTokenWindow={getTokenWindow}
            isCUICapable={isCUICapable}
            handleSubmit={handleSubmit}
            getTokenizer={getTokenizer}
            prevCommand={prevCommand}
            personas={personas}
            setChatLogAndSaveWithScroll={setChatLogAndSaveWithScroll}
            hideSidebar={hideSideBar}
            hideSideMemoBar={hideSideMemoBar}
            handleDetailsClick={handleDetailsClick}
            sources={sources}
          />
          <MemoMenu
            workbook={workbook}
            memos={memos}
            loadMemos={loadMemos}
            deleteMemo={deleteMemoR}
            setSideBarOpen={setSideMemoBarOpen}
            sideBarOpen={sideMemoBarOpen}
            hideSideBar={hideSideMemoBar}
            setHideSideBar={setHideSideMemoBar}
            selectedMemos={selectedMemos}
            setSelectedMemos={setSelectedMemos}
          />
      </div>
    </Stack>
    <FilePopup loadQuestions={loadQuestions} generateOverallSummary={generateOverallSummary} ingestURL={openURLPopup} loadSources={loadSources} addSource={addSource} paid={paid} dataset={current_dataset} workbook={workbook} setTriggerFilePopup={setTriggerFilePopup} triggerFilePopup={triggerFilePopup} />
    <AddURL
    loadQuestions={loadQuestions}
    generateOverallSummary={generateOverallSummary}
    workbook={workbook}
    loadSources={loadSources}
    triggerAddURL={triggerAddURL}
    setTriggerAddURL={setTriggerAddURL}
     />
    <Dialog
      open={detailsOpen}
      onClose={handleCloseDetails}
      aria-labelledby="workbook-details-title"
      aria-describedby="workbook-details-description"
      maxWidth="lg"
      fullWidth
    >
      <DialogTitle id="workbook-details-title" className="workspace-dialog-title">
        <Box display={'flex'} justifyContent={'space-between'}>
          <div>
            Workbook - {workbook.title}
            {hasShareAccess() === true ? 
            <IconButton style={{marginLeft: '10px'}} onClick={handleShareClick} className="workspace-icon-button">
              <FiShare2 style={{color: theme.palette.text.primary}} />
            </IconButton> : ''}
          </div>
          <IconButton onClick={handleCloseDetails} className="workspace-icon-button">
            <IoClose style={{color: theme.palette.text.primary}} />
          </IconButton>
        </Box>
      </DialogTitle>
      <ScrollableDialogContent className="workspace-dialog-content" modalIsOpen={true}>
        {/* Add your workbook details content here */}
        <Card className="workspace-card">
          <CardContent className="workspace-card-content">
            <p className="workspace-card-content-title">Overall Summary</p>
            <div className="markdownrenderer-div" style={{ maxHeight: '200px', margin: '20px', overflowY: 'auto' }}>
              {workbook.overall_summary && workbook.overall_summary !== '' ?
             <MarkdownRenderer style={{fontSize: '0.9em'}} content={workbook.overall_summary} user='bot' /> : 'No overall summary available'}
            </div>
            <p className="workspace-card-content-title">Workbook Actions</p>
            <div className="workspace-card-content-value">
              <Button onClick={() => handlePromptClick('bluf')} variant="contained" size="small">
                BLUF
              </Button>
              <Button onClick={() => handlePromptClick('insights')} variant="contained" size="small">
                Insights
              </Button>
              <Button onClick={() => handlePromptClick('toc')} variant="contained" size="small">
                Table of Content
              </Button>
              <Button onClick={() => handlePromptClick('executive_brief')} variant="contained" size="small">
                Executive Briefing
              </Button>
              <Button onClick={() => handlePromptClick('quiz')} variant="contained" size="small">
                Quiz
              </Button>
            </div>
            <p className="workspace-card-content-title">Memo-only Actions</p>
            <div className="workspace-card-content-value">
              <Button onClick={() => handlePromptClick('bluf', true)} variant="contained" size="small">
                BLUF
              </Button>
              <Button onClick={() => handlePromptClick('related_ideas', true)} variant="contained" size="small">
                Related Ideas
              </Button>
              <Button onClick={() => handlePromptClick('summarize', true)} variant="contained" size="small">
                Summarize
              </Button>
              <Button onClick={() => handlePromptClick('outline', true)} variant="contained" size="small">
                Outline
              </Button>
              <Button onClick={() => handlePromptClick('combine', true)} variant="contained" size="small">
                Combine
              </Button>
            </div>
            {questions ?
            <p className="workspace-card-content-title">Suggestions</p> : ''}
            <p className="workspace-card-content-value">
            {questions && questions.map((question, index) => (
              <Button onClick={() => handlePromptClick(question)} key={index} variant="contained" size="small">
                {question}
              </Button>
            ))}
            </p>
            {/* Add more details as needed */}
          </CardContent>
        </Card>
      </ScrollableDialogContent>
    </Dialog>
    <ShareWorkbookDialog open={triggerShare} setOpen={setTriggerShare} workbookToShare={workbook} />
    {/* Loading overlay */}
    {isLoading && (
      <div style={loading_styles.overlay}>
        <span style={loading_styles.loadingText}>{loadingText}</span>
      </div>
    )}
  </div>
);
}

export default Workbook;